/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"

function Seo({
  description,
  title,
  children,
  type,
  url,
  links,
  ogImage,
  ogTitle,
}) {
  const { site, logo } = useStaticQuery(
    graphql`
      query {
        site: site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
        logo: allFile(
          filter: {
            sourceInstanceName: { eq: "images" }
            relativeDirectory: { in: ["common/ogImage"] }
          }
        ) {
          nodes {
            id
            childImageSharp {
              original {
                src
              }
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const logoImg = logo?.nodes[0]?.childImageSharp?.original?.src
  const siteUrl = site.siteMetadata.siteUrl
  const fullTitle = title || defaultTitle

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type || "website"} />
      <meta property="og:image" content={ogImage || logoImg} />
      <meta property="og:image:secure_url" content={ogImage || logoImg} />
      {url && <meta property="og:url" content={siteUrl + url} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:domain" content={siteUrl || ``} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {links?.map((val, index) => (
        <link key={"link_" + index} rel={val.rel} href={siteUrl + val.href} />
      ))}
      <meta
        name="google-site-verification"
        content="V9yYxfdWDh90vlJMTfcTP5AHUC79ASQB2do2dFHYoQU"
      />
      {/* <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-BCYSQNRX9W"
      ></script> */}
      {children}
    </>
  )
}

export default Seo
